/**好友**/
<template>
  <div class="friendOrder">
    <div class="content">
      <h2>您成功推荐了<span>{{total}}</span>位好友</h2>
      <p class="content-divide">返利明细</p>
      <div class="content-inner" @scroll="scrollFn" v-show="content.length > 0">
        <div class="content-item" v-for="(item, index) in content" :key="index">
          <div class="content-item-text">
            <span class="phone">{{item.phone}}</span>
            <span class="money">￥{{item.money}}</span>
          </div>
          <div class="content-item-text">
            <span class="time">{{item.created | time}}</span>
            <!--<span class="time">现金</span>-->
          </div>
        </div>
      </div>
      <div style="line-height: 100px;color: #cccccc">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import JSONBig from 'json-bigint-xk'

  export default {
    name: 'affirm',
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      })
    },
    data () {
      return {
        rows: 10, // 获取的条数
        page: 1, // 第几页
        total: 0, // 总条数
        content: [] // 返回的数据集合
      }
    },
    methods: {
      /**
       * @returns void
       * @desc 触底加载下一页列表
       */
      scrollFn (e) {
        let scrollTop = e.currentTarget.scrollTop // 滚动条的高度
        let scrollHeight = e.currentTarget.scrollHeight // 滚动内容实际高度--不收overflow影响
        let offsetHeight = e.currentTarget.offsetHeight // 元素高度
        let top = Number(scrollTop + offsetHeight)
        if (top === scrollHeight) { // 滚动到了底部
          if (this.content.length < this.total) {
            this.page++
            this.getListFn()
          }
        }
      },
      /**
       * @returns void
       * @desc 获取分享数据
       */
      async getListFn () {
        let url = '/v1/queryMyRelation'
        let cookieAppKey = this.$Cookie.get('cookieAppKey') ? this.$Cookie.get('cookieAppKey') : null
        console.log('loginData', this.loginData)
        let passengerKey = 'passenger' + cookieAppKey
        let passenger = this.$Cookie.get(passengerKey) ? JSONBig.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerKey))) : null
        let params = {
          phone: passenger.passenger.phone,
          referee_id: passenger.passenger.id,
          referee_type: 2, // 1--服务人员,2--客户
          limit: this.rows,
          page: this.page
        }
        let data = await this.$axios.get(url, params)
        if (data && data.code === 1) {
          this.total = data.total || 0
          let content = data.relation || []
          if (this.page === 1) {
            this.content = content
          } else if (this.page > 1) {
            this.orderList = this.orderList.concat(content)
          }
        }
      }
    },
    mounted () {
      // let that = this
      this.getListFn()
      // that.$store.dispatch('checkLogin', (state) => {
      //   if (state) {
      //     that.$store.dispatch('queryRecommendRecord', {
      //       page: that.page,
      //       rows: that.rows,
      //       passengerId: that.loginData.passenger.id,
      //       type: 'upData'
      //     })
      //   }
      // })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .friendOrder {
    text-align: center;
    height: 100%;
    background-color: #fff;
    .content {
      padding: 0 12px;
      height: 100%;
      overflow: hidden;
      h2 {
        color: #333;
        line-height: 100px;
        height: 100px;
        font-size:14px;
        font-weight:400;
        color:rgba(34,34,34,1);
        span {
          color: #F14E30;
          font-size: 25px;
        }
      }
      .content-inner{
        overflow: auto;
        height: calc(~'100% - 120px');
      }
      .content-divide{
        font-size:12px;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:17px;
        position: relative;
        &:before{
          content: '';
          width: 136px;
          height: 1px;
          background-color: #EBEBEB;
          position: absolute;
          top: 8px;
          left: 0;
        }
        &:after{
          content: '';
          width: 136px;
          height: 1px;
          background-color: #EBEBEB;
          position: absolute;
          top: 8px;
          right: 0;
        }
      }
      .content-item{
        height: 62px;
        padding: 12px 0;
        box-sizing: border-box;
        border-bottom: 1px #EBEBEB solid;
        .content-item-text{
          display: flex;
          justify-content: space-between;
          .phone{
            font-size:15px;
            font-weight:400;
            color:rgba(34,34,34,1);
          }
          .money{
            font-size:15px;
            font-weight:500;
            color:rgba(241,77,47,1);
          }
          .time{
            font-size:12px;
            font-weight:400;
            color:rgba(153,153,153,1);
          }
        }
      }
      .recordOrder {
        box-sizing: border-box;
        margin-top: 1.5rem;
        width: 100%;
        padding: 0 1rem;
        table {
          width: 100%;
          border-collapse: collapse; /* 边框合并属性  */
          td, th {
            box-sizing: border-box;
            width: 25%;
            padding: 0 0.6rem;
            height: 2.5rem;
            line-height: 2.5rem;
            text-align: center;
          }
        }
        .Title {
          overflow: hidden;
          th {
            background: #ffd8d6;
            color: #666666;
          }
        }
        .Tbody {
          border: 1px solid #ffd8d6;
          max-height: 25rem;
          overflow: hidden;
          overflow-y: scroll;
          td {
            color: #333333;
          }
          .rebate {
            color: #f06553;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// friend.vue?bce499a6